export default __webpack_public_path__ + "static/Olark-ed54e62485c586619bbf1afe6dbcd1de.png";